import Layout from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { BookOpen, Video, Newspaper } from 'lucide-react';

const Media = () => {
  const upcomingContent = [
    {
      type: 'Guide',
      icon: BookOpen,
      title: 'The Ultimate Beginner\'s Guide to Surfing',
      description: 'Everything you need to know before catching your first wave.',
      status: 'Coming Soon'
    },
    {
      type: 'Video',
      icon: Video,
      title: 'Surf Etiquette 101',
      description: 'Learn the unwritten rules of the lineup from pro surfers.',
      status: 'Coming Soon'
    },
    {
      type: 'Article',
      icon: Newspaper,
      title: 'Best Time to Surf in Indonesia',
      description: 'A month-by-month breakdown of Indonesia\'s epic surf season.',
      status: 'Coming Soon'
    },
    {
      type: 'Guide',
      icon: BookOpen,
      title: 'Packing for a Surf Trip',
      description: 'The essential gear checklist for your next surf adventure.',
      status: 'Coming Soon'
    },
    {
      type: 'Video',
      icon: Video,
      title: 'Reading Ocean Conditions',
      description: 'Understanding swells, tides, and wind for better sessions.',
      status: 'Coming Soon'
    },
    {
      type: 'Article',
      icon: Newspaper,
      title: 'Solo Surf Trip Safety Tips',
      description: 'How to stay safe while traveling and surfing alone.',
      status: 'Coming Soon'
    }
  ];

  return (
    <Layout>
      <Seo
        title="Surf Media | Stories, Guides and Films from Swell Breaks"
        description="Read surf destination stories, guides and long-form travel features from Swell Breaks."
        path="/media"
      />
      <section className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-4">
              Surf Media
            </h1>
            <p className="text-muted-foreground max-w-lg mx-auto">
              Guides, stories, and tips from the global surf community
            </p>
          </div>

          {/* Coming Soon Notice */}
          <div className="mb-12 p-8 bg-card rounded-2xl border border-border/50 text-center">
            <Badge variant="secondary" className="mb-4">In Development</Badge>
            <h2 className="font-serif text-2xl font-semibold text-foreground mb-3">
              Content Coming Soon
            </h2>
            <p className="text-muted-foreground max-w-md mx-auto">
              We're working on an amazing collection of surf guides, videos, and articles. 
              Check back soon for fresh content!
            </p>
          </div>

          {/* Preview Grid */}
          <h3 className="font-serif text-xl font-semibold text-foreground mb-6">What's Coming</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {upcomingContent.map((item, idx) => (
              <Card key={idx} className="border-dashed border-border/60 hover:border-primary/40 transition-colors">
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-primary/10">
                      <item.icon className="h-5 w-5 text-primary" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <Badge variant="outline" className="text-xs">{item.type}</Badge>
                        <Badge variant="secondary" className="text-xs">{item.status}</Badge>
                      </div>
                      <h4 className="font-semibold text-foreground mb-1">{item.title}</h4>
                      <p className="text-sm text-muted-foreground">{item.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Media;
